import * as yup from 'yup';

export const schemaSafie = yup.object().shape({
  key: yup.string().nullable().required('SafieAPIキーを入力してください'),
});
